/**
 * @file Object utility functions.
 * @author andreas.z.hellstrom@teliacompany.com (Andreas Hellström)
 */

//------------------------------------------------------------------------------
// Exported functions
//------------------------------------------------------------------------------

/** Create a copy of an object that contains elements of these types: Object,
 * Array, Date, String, Number or Boolean. Also, data in objects and arrays need
 * to form a tree structure. That is, there isn't more than one reference to the
 * same data in the object.
 *
 * Source: https://stackoverflow.com/questions/728360/how-do-i-correctly-clone-a-javascript-object
 *
 * @param {Object | Array | Date | String | Number | Boolean} obj
 * @returns {*} Copy of input object
 */
export function deepClone(obj) {
  let copy;

  // Handle the 3 simple types, and null or undefined
  if (obj == null || typeof obj !== 'object') return obj;

  // Handle Date
  if (obj instanceof Date) {
    copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }

  // Handle Array
  if (obj instanceof Array) {
    copy = [];
    for (let i = 0, len = obj.length; i < len; i++) {
      copy[i] = deepClone(obj[i]);
    }
    return copy;
  }

  // Handle Object
  if (obj instanceof Object) {
    copy = {};

    Object.keys(obj).forEach((attr) => {
      if (Object.prototype.hasOwnProperty.call(obj, attr)) {
        if (Object.prototype.hasOwnProperty.call(obj, attr)) copy[attr] = deepClone(obj[attr]);
      }
    });

    return copy;
  }

  throw new Error("Unable to copy obj! Its type isn't supported.");
}
